import module from 'recursoshumanos/module.js'
import template from './template.html'
import { difference, isArray, isDate, isFinite, isString, orderBy } from 'lodash'

export class RecursoshumanosVisorlotesConfiguracionComponent {
  idEmpresa
  clase
  registroPatronalId
  proyectos
  fecha
  onChange
  buscandoEmpresas = false
  buscandoClases = false
  buscandoProyectos = false
  catalogo = {
    empresa: null,
    clase: null,
    proyecto: null,
  }

  constructor ($q, RecursosHumanosEmpresas, RecursosHumanosClasePrimaDeRiesgo, RecursosHumanosEmpresaProyectos, RecursosHumanosClasePrimaDeRiesgoRegistroPatronales) {
    this.$q = $q
    this.RecursosHumanosEmpresas = RecursosHumanosEmpresas
    this.RecursosHumanosClasePrimaDeRiesgo = RecursosHumanosClasePrimaDeRiesgo
    this.RecursosHumanosEmpresaProyectos = RecursosHumanosEmpresaProyectos
    this.RecursosHumanosClasePrimaDeRiesgoRegistroPatronales = RecursosHumanosClasePrimaDeRiesgoRegistroPatronales
  }

  $onChanges (changes) {
    this.idEmpresa = isString(this.idEmpresa) ? this.idEmpresa : undefined
    this.clase = isFinite(this.clase) ? this.clase : undefined
    this.proyectos = isArray(this.proyectos) ? this.proyectos : []
    this.fecha = isDate(this.fecha) ? this.fecha : null

    if (changes.idEmpresa && changes.idEmpresa.isFirstChange()) {
      this.buscarEmpresas()
      this.buscarEmpresaClases()
    }

    if (changes.idEmpresa && changes.idEmpresa.isFirstChange() && changes.clase && changes.clase.isFirstChange()) {
      this.buscarRegistroPatronales()
    }

    if (changes.idEmpresa) {
      this.buscarEmpresaProyectos()
    }
  }

  buscarEmpresas () {
    if (this.buscandoEmpresas) return

    this.buscandoEmpresas = true
    this.RecursosHumanosEmpresas.get()
      .then(({data}) => (this.catalogo.empresa = orderBy(data.map((item) => ({id: item.id_empresa, descripcion: item.nombre})), ['descripcion'])))
      .then(() => (this.validarEmpresa()))
      .finally(() => (this.buscandoEmpresas = false))
  }

  buscarEmpresaClases () {
    if (this.buscandoClases || !this.idEmpresa) return

    this.buscandoClases = true
    this.RecursosHumanosClasePrimaDeRiesgo.get()
      .then(({data}) => (this.catalogo.clase = orderBy(data.map((item) => ({id: +item.id, descripcion: item.descripcion}), ['id']))))
      .then(() => this.validarEmpresaClase())
      .finally(() => (this.buscandoClases = false))
  }

  buscarRegistroPatronales() {
    if(!this.idEmpresa && !this.clase) return

    this.RecursosHumanosClasePrimaDeRiesgoRegistroPatronales.get(this.idEmpresa, this.clase)
      .then(({data}) => (this.registrosPatronales = data))
      .then(() => (this.validarRegistroPatronal()))
  }

  buscarEmpresaProyectos () {
    if (this.buscandoProyectos || !this.idEmpresa) return

    this.buscandoProyectos = true
    this.RecursosHumanosEmpresaProyectos.get(this.idEmpresa)
      .then(({data}) => (this.catalogo.proyecto = orderBy(data.map((item) => ({id: item.id_empresa, descripcion: item.nombre})), ['descripcion'])))
      .then(() => this.validarEmpresaProyecto())
      .finally(() => (this.buscandoProyectos = false))
  }

  notificarCambio () {
    this.onChange({
      $event: {
        detail: {
          idEmpresa: this.idEmpresa,
          clase: this.clase,
          registroPatronalId: this.registroPatronalId,
          proyectos: this.proyectos,
          fecha: this.fecha}}})
  }

  validarRegistroPatronal() {
    if(!this.registrosPatronales.length) return
    if(!this.registrosPatronales.map(i => i.id).includes(this.registroPatronalId)) {
      this.registroPatronalId = undefined
    }
  }

  validarEmpresa () {
    if (!this.catalogo.empresa) return
    if (this.idEmpresa && !this.catalogo.empresa.map((item) => item.id).includes(this.idEmpresa)) {
      this.idEmpresa = undefined
      this.clase = undefined
      this.proyectos = []
      this.catalogo.clase = null
      this.catalogo.proyecto = null
      this.notificarCambio()
    }
  }

  validarEmpresaClase () {
    if (!this.idEmpresa) this.catalogo.clase = null
    if (!this.catalogo.clase) return
    if (this.clase && (!this.idEmpresa || !this.catalogo.clase.map((item) => item.id).includes(this.clase))) {
      this.clase = undefined
      this.notificarCambio()
    }
  }

  validarEmpresaProyecto () {
    if (!this.idEmpresa) this.catalogo.proyecto = null
    if (!this.catalogo.proyecto) return
    if (this.proyectos.length && (!this.idEmpresa || difference(this.proyectos, this.catalogo.proyecto.map((item) => item.id)).length > 0)) {
      this.proyectos = []
      this.notificarCambio()
    }
  }
}

module.component('recursoshumanosVisorlotesConfiguracion', {
  controller: RecursoshumanosVisorlotesConfiguracionComponent,
  template,
  bindings: {
    idEmpresa: '<',
    clase: '<',
    registroPatronalId: '<',
    proyectos: '<',
    fecha: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/configuracion/component.js